import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const NAVY  = [11, 31, 58];
const BLUE  = [26, 111, 196];
const WHITE = [255, 255, 255];

const addHeader = (doc, municipio, titulo, periodo) => {
  doc.setFillColor(...NAVY);
  doc.rect(0, 0, 210, 28, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.setTextColor(...WHITE);
  doc.text('PREFEITURA RESOLVE', 14, 12);
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(144, 184, 216);
  doc.text('Sistema de Proteção de Receita Municipal', 14, 18);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(...WHITE);
  doc.text(municipio, 196, 12, { align: 'right' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(144, 184, 216);
  doc.text(`Período: ${periodo}`, 196, 18, { align: 'right' });
  doc.text(`Emissão: ${new Date().toLocaleDateString('pt-BR')}`, 196, 23, { align: 'right' });

  doc.setFillColor(...BLUE);
  doc.rect(0, 28, 210, 10, 'F');
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(11);
  doc.setTextColor(...WHITE);
  doc.text(titulo, 105, 35, { align: 'center' });
};

const addFooter = (doc) => {
  const pages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pages; i++) {
    doc.setPage(i);
    doc.setFontSize(7);
    doc.setTextColor(150);
    doc.text('Sistema Prefeitura Resolve  ·  Proteção de Receita Municipal', 14, 290);
    doc.text(`Página ${i} de ${pages}`, 196, 290, { align: 'right' });
  }
};

export const gerarRelatorioVAF = (empresas, config = {}) => {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  addHeader(doc, config.municipio || 'Município', 'RELATÓRIO VAF / ICMS', config.periodo || '2024');

  // Resumo
  const totalPerda = empresas.reduce((s, e) => s + (e.perda || 0), 0);
  const criticas   = empresas.filter(e => e.status === 'critico').length;
  doc.setFontSize(9);
  doc.setTextColor(...NAVY);
  doc.text(`Total de empresas monitoradas: ${empresas.length}   |   Empresas críticas: ${criticas}   |   Perda potencial total: R$ ${totalPerda.toLocaleString('pt-BR')}`, 14, 46);

  autoTable(doc, {
    startY: 50,
    head: [['#', 'Empresa / CNPJ', 'VAF 2023', 'VAF 2024', 'Variação', 'Perda (R$)', 'Status', 'Prazo']],
    body: empresas.sort((a, b) => b.perda - a.perda).map((e, i) => [
      `${i + 1}°`,
      `${e.nome}\n${e.cnpj}`,
      `R$ ${(e.vafAnt || 0).toLocaleString('pt-BR')}`,
      `R$ ${(e.vafAt  || 0).toLocaleString('pt-BR')}`,
      `${e.variacao?.toFixed(1)}%`,
      `R$ ${(e.perda  || 0).toLocaleString('pt-BR')}`,
      e.status?.toUpperCase(),
      `${e.prazo} dias`,
    ]),
    headStyles:  { fillColor: NAVY, textColor: WHITE, fontSize: 8, fontStyle: 'bold' },
    bodyStyles:  { fontSize: 8 },
    alternateRowStyles: { fillColor: [240, 244, 250] },
    columnStyles: {
      0: { cellWidth: 8  },
      1: { cellWidth: 52 },
      2: { cellWidth: 24 },
      3: { cellWidth: 24 },
      4: { cellWidth: 18 },
      5: { cellWidth: 26 },
      6: { cellWidth: 20 },
      7: { cellWidth: 18 },
    },
    didParseCell: (data) => {
      if (data.section === 'body' && data.column.index === 6) {
        const v = data.cell.raw || '';
        if (v.includes('CRITICO')) data.cell.styles.textColor = [230, 57, 70];
        if (v.includes('ATENCAO')) data.cell.styles.textColor = [200, 140, 0];
        if (v.includes('MONITORAR')) data.cell.styles.textColor = [45, 150, 83];
      }
    },
  });

  addFooter(doc);
  doc.save(`relatorio_vaf_${new Date().toISOString().slice(0,10)}.pdf`);
};

export const gerarRelatorioIBS = (contratos, config = {}) => {
  const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
  addHeader(doc, config.municipio || 'Município', 'RELATÓRIO IBS – REFORMA TRIBUTÁRIA', config.periodo || '2024');

  const totalValor = contratos.reduce((s, c) => s + (c.valor || 0), 0);
  const totalIbs   = contratos.reduce((s, c) => s + (c.ibs   || 0), 0);
  doc.setFontSize(9);
  doc.setTextColor(...NAVY);
  doc.text(`Volume contratado: R$ ${totalValor.toLocaleString('pt-BR')}   |   IBS estimado total: R$ ${totalIbs.toLocaleString('pt-BR')}   |   Alíquota: 8,4%`, 14, 46);

  autoTable(doc, {
    startY: 50,
    head: [['Contrato', 'Fornecedor', 'Valor (R$)', 'Secretaria', 'Município', 'IBS Est.', 'Status']],
    body: contratos.map(c => [
      c.numero,
      c.fornecedor,
      `R$ ${(c.valor || 0).toLocaleString('pt-BR')}`,
      c.secretaria || '—',
      c.municipio  || '—',
      `R$ ${(c.ibs  || 0).toLocaleString('pt-BR')}`,
      c.status?.toUpperCase(),
    ]),
    headStyles: { fillColor: NAVY, textColor: WHITE, fontSize: 8, fontStyle: 'bold' },
    bodyStyles: { fontSize: 8 },
    alternateRowStyles: { fillColor: [240, 244, 250] },
  });

  addFooter(doc);
  doc.save(`relatorio_ibs_${new Date().toISOString().slice(0,10)}.pdf`);
};
